export const home_path = '/';
export const creator_path = '/@/creator/explore';
export const shop_path = '/@/goods/ranking';
export const curation_path = '/@/curations';
